import React, { useMemo, useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { indiaLogo, indiaLogoV2 } from "../input-reg-no/constants";
import { formatInputValue } from "../input-reg-no/selector";

const InputRegNoPlate = React.memo(({
    placeholder = "DL 01 AB12XX",
    isError,
    errorMessage,
    // value,
    onChange,
    isChallan = false,
    maxLength = null
    // ref
}) => {
    const [value, setValue] = useState("");
    const sanitizedValue = useMemo(() => formatInputValue({ inputValue: value }), [value]);

    const handleOnChange = (e) => {
        const val = e.target.value;
        if (val && maxLength && val.length > maxLength) {
            return;
        }
        setValue(val);
        window.setTimeout(() => {
            const regexp = /[^a-z0-9]/gi;
            const newVal = (val || "").replace(regexp, "");
            onChange(newVal);
        }, 0);
    };

    return (
        <div styleName={`${"styles.inputShift"} ${`styles.prefixImg`} ${isChallan ? "styles.challanImage" : ""} `}>
            <div dangerouslySetInnerHTML={{ __html: isChallan ? indiaLogoV2 : indiaLogo }} />
            <input
                // ref={ref}
                type={"text"}
                className="form-control"
                value={sanitizedValue}
                onChange={handleOnChange}
                placeholder={placeholder}
            />
            {
                <small styleName={`styles.error ${isError ? "styles.showError" : "styles.hideError"}`}>{errorMessage}</small>
            }
        </div>
    );
});

InputRegNoPlate.propTypes = {
    placeholder: PropTypes.string,
    isError: PropTypes.bool,
    errorMessage: PropTypes.string,
    // value: PropTypes.string,
    onChange: PropTypes.func,
    isChallan: PropTypes.bool,
    maxLength: PropTypes.number
    // ref: PropTypes.any
};

export default InputRegNoPlate;
